import { computed, observable, action, makeObservable } from 'mobx';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { validateRequire } from 'src/domains/players/webview/components/ValidatorsNew';
import { SelectedOptionType } from 'src/domains/players/webview/components/form/selectNew/SelectNew';
import { Common } from 'src/domains/common/Common';
import { DateTime } from 'src_common/utils/time/time';
import { AccountReviewReminderState } from 'src/domains/players/state/AccountReviewReminderState';

export class AccountReviewState {
    @observable public showInfo: boolean = false;
    @observable public loader: boolean = false;

    public accountReviewInput: FormInputState<string, string>;
    private readonly reminderState: AccountReviewReminderState;

    public constructor(
        public readonly language: LanguagesState,
        common: Common
    ) {
        makeObservable(this);
        this.language = language;
        this.reminderState = AccountReviewReminderState.get(common);
        this.accountReviewInput = FormInputState.new('').map(validateRequire);
    }

    @computed public get accountReviewOptions(): SelectedOptionType[] {
        return [
            { label: this.language.getTranslation('account.account-review.1', '1 Month'), value: '30' },
            { label: this.language.getTranslation('account.account-review.3', '3 Months'), value: '90' },
            { label: this.language.getTranslation('account.account-review.6', '6 Months'), value: '180' },
        ];
    }

    @computed public get nextReviewDate(): string | null {
        const result = this.reminderState.accountReviewResource.get();
        if (result.type !== 'ready' || result.value === null) {
            return null;
        }

        const data = result.value;
        const lastDate = DateTime.from(data.lastReminderDate);
        if (lastDate === null) {
            return null;
        }

        const nextDate = lastDate.addDays(data.reminderFrequency);
        return nextDate.format('YYYY-MM-DD HH:mm');
    }

    @action public setIsLoading = (value: boolean): void => {
        this.loader = value;
    };
    @action public setShowInfo = (value: boolean): void => {
        this.showInfo = value;
    };

    @action public onSubmitaccountReviewForm = async (): Promise<void> => {
        this.setShowInfo(false);

        if (this.accountReviewInput.result.value.type === 'error') {
            return;
        }

        this.setIsLoading(true);

        const reminderFrequency = parseInt(this.accountReviewInput.result.value.data, 10);
        const lastReminderDate = new Date().toISOString();

        const success = await this.reminderState.sendAccountReviewReminder(reminderFrequency, lastReminderDate);

        this.setIsLoading(false);

        if (success) {
            await this.reminderState.accountReviewResource.refresh();
            this.setShowInfo(true);
        }
    };
}
